/*
  This method is basically identical with comm api's
  handle_no_specified_employee_contribution method in
  commercial-api/mozart/domain_logic/health_savings_account.py

  The only differnce is that handle_no_specified_employee_contribution
  also factors in earned incentives.

  Comm API also doesn't currently return the assumed
  employee contribution produced by handle_no_specified_employee_contribution
  in the recommendation response.

  We should consider adding the employee value produced by
  handle_no_specified_employee_contribution in the Comm API
  recommendation response and deprecating this method in favor of that
*/
export function calculateHsaRecommendation(
  oopEstimate: number,
  hsaPercentageMatch: number | null,
  employerHsaContributionLimit: number | null,
  hsaContributionLimit: number,
  employerHsaContribution: number | null,
) {
  if (hsaPercentageMatch && hsaPercentageMatch > 0) {
    // Calculate the recommended contribution after employer match
    const percentageMatch = hsaPercentageMatch / 100;
    const employerLimit =
      employerHsaContributionLimit && employerHsaContributionLimit > 0
        ? Math.min(employerHsaContributionLimit, hsaContributionLimit)
        : hsaContributionLimit;
    const totalToContribute = Math.min(oopEstimate, hsaContributionLimit);
    const employerMatch = Math.min(
      (totalToContribute * percentageMatch) / (1 + percentageMatch),
      employerLimit,
    );
    const recommendedContribution = totalToContribute - employerMatch;
    return recommendedContribution;
  }

  // Else return recommended employee contribution for fixed employer contributions
  const hsaOopEstimate = Math.max(oopEstimate - (employerHsaContribution || 0), 0);
  const maxEmployeeContribution = hsaContributionLimit
    ? Math.max(hsaContributionLimit - (employerHsaContribution || 0), 0)
    : null;
  return maxEmployeeContribution ? Math.min(maxEmployeeContribution, hsaOopEstimate) : hsaOopEstimate;
}
